import moment from "moment";

export const COLUMNS = [
	{
		Header: 'Descripción',
		accessor: 'descripcion'
	},
	{
		Header: 'Valor / U. Medida',
		accessor: 'valor',
		Cell: ({ row }) =>
			row.original.valor + " / " + row.original.unidadMedida
	},
	{
		Header: 'Fecha Registro',
		accessor: 'fechaHoraCreacion',
		Cell: ({ row }) =>
			moment(row.original.fechaHoraCreacion).format('DD-MM-YYYY HH:mm:ss')

	},
]

export const COLUMNAS_CARGA_INFORMES = [
	{
		Header: 'ID',
		accessor: 'planConservacionId',
		className: 'text-nowrap'
	},
	{
		Header: 'A\u00f1o',
		accessor: 'ano',
		className: 'text-nowrap'
	},
	{
		Header: 'Trimestre',
		accessor: 'trimestre',
		className: 'text-nowrap',
		Cell: ({ row }) => row.original.trimestre ?? ''
	},
	{
		Header: 'Indicador',
		accessor: 'indicador',
		className: 'text-nowrap'
	},
	{
		Header: 'Exigencia',
		accessor: 'exigencia',
		className: 'text-nowrap'
	},
	{
		Header: 'Fecha Planificada de Carga',
		accessor: 'fechaPlanificada',
		Cell: ({ row }) =>
			row.original.fechaPlanificada ? moment(row.original.fechaPlanificada).format('DD-MM-YYYY HH:mm:ss') : '',
		className: 'text-nowrap'
	},
	{
		Header: 'Fecha Real de Carga',
		accessor: 'fechaCarga',
		Cell: ({ row }) =>
			row.original.fechaCarga ? moment(row.original.fechaCarga).format('DD-MM-YYYY HH:mm:ss') : '',
		className: 'text-nowrap'
	},
	{
		Header: 'D\u00edas de Incumplimiento',
		accessor: 'diasIncumplimiento',
		className: 'text-nowrap'
	},
	{
		Header: 'Estado',
		accessor: 'estadoPlan',
		className: 'text-nowrap',
		Cell: ({ row }) => row.original.estadoPlan ?? ''
	}
]
